export default __webpack_public_path__ + "static/img1-909d2be78b61bbfc36e5dde534b59351.jpg";